// extracted by mini-css-extract-plugin
export var bodySections = "_76-8";
export var gray = "_76-7";
export var green = "_76-4";
export var iconContainer = "_76-9";
export var iconWidgetContainer = "_76-1";
export var phoneIcon = "_76-2";
export var red = "_76-5";
export var statusDot = "_76-3";
export var widgetContainer = "_76-0";
export var yellow = "_76-6";